import { useState, useEffect } from "react";
import { Outlet, Navigate } from "react-router-dom";

import Header from "@/components/header";
import Sidebar from "./sidebar";

import Loader from "@/components/loader";

import api from "@/services/api";

import useStore from "@/services/store";

export const Layout = () => {
  const { user, setUser, setOrganization } = useStore();
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    verifyToken();
  }, []);

  async function verifyToken() {
    try {
      const { ok, token, user, organisations } = await api.get("/user/signin_token");
      if (!ok) return setUser(null);
      setUser(user);
      const stored = useStore.getState().organization;
      const stillValid = stored && organisations?.find((o) => o._id === (stored._id || stored.id));
      setOrganization(stillValid ? stored : organisations?.[0] || null);
      if (token) api.setToken(token);
    } catch (e) {
      console.log(e);
    } finally {
      setLoading(false);
    }
  }

  if (loading)
    return (
      <div className="flex justify-center items-center h-screen">
        <Loader />
      </div>
    );
  if (!user) return <Navigate to="/auth" replace={true} />;

  if (!user.role_recruiter) return <Navigate to="/" replace />;

  return (
    <div className="h-screen overflow-hidden bg-gray-50">
      <Header />
      <Sidebar />
      <main className="lg:ml-64 mt-16 h-[calc(100vh-64px)] overflow-auto bg-white">
        <Outlet />
      </main>
    </div>
  );
};
